import Core from '../core';
import { AxiosError, AxiosRequestConfig } from 'axios';

const api = Core.getInstance().api();

async function login(payload: any) {
  const data = await api.post(`/login`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function canAccessEmployeePortal(company_id: number) {
  const data = await api.get(
    `/v1/access/employee_portal_access?company_id=${company_id}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getCompanDetail(
  companyID: number,
  options?: AxiosRequestConfig,
) {
  const data = await api.get(
    `/v1/employee/getEmpCompanyDetail?company_id=${companyID}`,
    options,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function checkLoginStatus() {
  const data = await api.get(`/checkLoginStatus`);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function getBankDetail(companyId: number, empId: number) {
  const data = await api.get(
    `/v1/employee/bankDetails?companyId=${companyId}&empId=${empId}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getPayoutTypes() {
  const data = await api.get(
    `v1/config/payout/types?locale=${localStorage.getItem('emplang')}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getAgentId(companyId: number, typeId: number, name: string) {
  const data = await api.get(
    `v1/config/payout/getAgentId?company_id=${companyId}&type_id=${typeId}&name=${name}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
export const userService = {
  getCompanDetail,
  login,
  checkLoginStatus,
  getBankDetail,
  getPayoutTypes,
  getAgentId,
  canAccessEmployeePortal,
};
